package nl.astraeus.wiki.oauth

fun generateRandom() = "4"

data class OauthClient(
  val clientId: String,
  val clientSecret: String,
  val oauthState: String = generateRandom()
)
